export default __webpack_public_path__ + "static/media/050_brake.first.2204cbc9.avif";